import * as React from "react";
const SvgFiRrSiren = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-Siren_svg__a)">
      <path
        fill="#062147"
        d="M21.224 17.192 19.935 4.303A4.76 4.76 0 0 0 15.181.001H8.82a4.763 4.763 0 0 0-4.754 4.302L2.777 17.192A4.01 4.01 0 0 0 .001 21c0 1.654 1.346 3 3 3h18c1.654 0 3-1.346 3-3a4.01 4.01 0 0 0-2.777-3.808M6.056 4.501A2.77 2.77 0 0 1 8.82 2h6.361a2.77 2.77 0 0 1 2.764 2.501L19.195 17H4.806zM21 22H3c-.551 0-1-.449-1-1 0-1.103.897-2 2-2h16c1.103 0 2 .897 2 2 0 .551-.449 1-1 1M7.825 6.9l.2-2A1 1 0 0 1 9.02 4h1.979a1 1 0 0 1 0 2H9.924l-.11 1.1a1 1 0 1 1-1.991-.2z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-Siren_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSiren;
